module.exports = __webpack_public_path__ + "img/nathalie_flower_field.70fd2027.jpg";